import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword,
} from "firebase/auth";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [currentPasswordError, setCurrentPasswordError] = useState(""); // State for current password error

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation for new password and confirm password
    if (newPassword !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
      return;
    }

    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
      try {
        // Re-authenticate the user with the current password
        const credential = EmailAuthProvider.credential(
          user.email,
          currentPassword
        );
        await reauthenticateWithCredential(user, credential);

        // Change the password
        await updatePassword(user, newPassword);

        setSuccessMessage("Password successfully updated.");
        setErrorMessage(""); // Clear any previous error messages
        setCurrentPasswordError(""); // Clear current password error message

        // Optionally navigate to another page
        navigate("/dashboard"); // Redirect to the profile page (or another page)
      } catch (error) {
        if (error.code === "auth/wrong-password") {
          // Clear all fields if the current password is incorrect
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setCurrentPasswordError("Current password is incorrect.");
        } else {
          setCurrentPasswordError(""); // Clear current password error
          setErrorMessage("Please check current password. try again.");
        }
      }
    } else {
      setErrorMessage("User is not authenticated.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="max-w-md w-full bg-white p-6">
        <button
          onClick={() => navigate("/dashboard")}
          className="absolute top-4 left-4 text-blue-500 flex items-center"
        >
          <i className="fas fa-arrow-left mr-2"></i> Back to Dashboard
        </button>
        <h2 className="text-xl font-semibold mb-4 text-center">
          Change Password
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="currentPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Current Password
            </label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              className="mt-1 px-4 py-2 w-full border border-gray-300 rounded-md"
            />
            {currentPasswordError && (
              <p className="text-red-500 text-sm mt-2">
                {currentPasswordError}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label
              htmlFor="newPassword"
              className="block text-sm font-medium text-gray-700"
            >
              New Password
            </label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="mt-1 px-4 py-2 w-full border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-gray-700"
            >
              Confirm New Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="mt-1 px-4 py-2 w-full border border-gray-300 rounded-md"
            />
          </div>

          {errorMessage && (
            <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
          )}

          {successMessage && (
            <p className="text-green-500 text-sm mt-2">{successMessage}</p>
          )}

          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
